import { TAccordionTableVM } from './accordion-table.types';

export const ACCORDION_COMMON_TASKS = {
  logAccordionModel: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    console.log('[ACCORDION MODEL]: ', accordionModel);
    return accordionModel;
  },
};

export const ACCORDION_SELECT_TASKS = {
  addSelectFeature: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    const selectOptions = accordionModel.options?.select;
    if (!selectOptions) return accordionModel;
    return {
      ...accordionModel,
      accordions: accordionModel.accordions.map((accordion) => {
        return {
          ...accordion,
          accordionSelectionInfo: {
            ...accordion.accordionSelectionInfo,
            isSelected: accordion.accordionSelectionInfo?.isSelected ?? false,
            isDisabled: accordion.accordionSelectionInfo?.isDisabled ?? false,
          },
        };
      }),
      options: {
        ...accordionModel.options,
        select: {
          isMulti: selectOptions.isMulti,
          selectAllChecked: false,
          selectAllApplicable: true,
          selectAllIndeterminate: false,
        },
      },
    };
  },
  updateAccordionSelect: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    const { options, accordions } = accordionModel;
    const selectedAccordions = accordions.filter((accordion) => accordion.accordionSelectionInfo?.isSelected);
    const enabledAccordions = accordions.filter((accordion) => !accordion.accordionSelectionInfo?.isDisabled);
    const isIndeterminate = selectedAccordions.length > 0 && selectedAccordions.length < enabledAccordions.length;
    const isAllChecked = selectedAccordions.length === enabledAccordions.length && enabledAccordions.length > 0;
    return {
      ...accordionModel,
      options: {
        ...options,
        ...(options?.select && {
          select: {
            ...options?.select,
            selectAllChecked: isAllChecked,
            selectAllIndeterminate: isIndeterminate,
          },
        }),
      },
    };
  },
  hideSingleSelectHeader: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    return {
      ...accordionModel,
      options: {
        ...accordionModel.options,
        ...(accordionModel.options?.select && {
          select: {
            ...accordionModel.options.select,
            selectAllApplicable: accordionModel.options.select.isMulti,
          },
        }),
      },
    };
  },
};
